export default __webpack_public_path__ + "static/media/search.28f05516.svg";